export const frontmatter = {
    "draft": false,
    "title": "Guía: Chatbots",
    "description": "Cómo crear y configurar chatbots conversacionales en OnnIA. Tipos de chatbot: Agente simple, Enrutador, Secuencial y Paralelo.",
    "sidebar_label": "Chatbots",
    "sidebar_group": "referencia",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "tipos-de-chatbot",
        "value": "Tipos de chatbot"
    },
    {
        "depth": 2,
        "id": "agente-simple-monoagente",
        "value": "Agente simple (Monoagente)"
    },
    {
        "depth": 2,
        "id": "derivacion-inteligente-enrutador",
        "value": "Derivación inteligente (Enrutador)"
    },
    {
        "depth": 2,
        "id": "paso-a-paso-secuencial",
        "value": "Paso a paso (Secuencial)"
    },
    {
        "depth": 2,
        "id": "equipo-de-expertos-paralelo",
        "value": "Equipo de expertos (Paralelo)"
    },
    {
        "depth": 2,
        "id": "configuracion-del-widget",
        "value": "Configuración del widget"
    }
]